import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import TagsPage from 'flarum/forum/tags/components/TagsPage';
import PagePagePC from './components/PagePagePC';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import Link from 'flarum/common/components/Link';
import SearchSource from 'flarum/forum/components/Search';
import ComposerBody from 'flarum/forum/components/ComposerBody';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import Navigation from 'flarum/common/components/Navigation';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import SearchButton from '../common/components/SearchButton';
import PostButton from '../common/components/PostButton';
import UploadFileButton from '../common/components/UploadFileButton';
import HomePage from './components/HomePage';
import TextEditor from 'flarum/common/components/TextEditor';
import listItems from 'flarum/common/helpers/listItems';
import ComposerState from 'flarum/forum/states/ComposerState';
import Composer from 'flarum/forum/components/Composer';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionListPane from 'flarum/forum/components/DiscussionListPane';
import PostUser from 'flarum/forum/components/PostUser';
import PostStream from 'flarum/forum/components/PostStream';
import PostLoading from 'flarum/forum/components/LoadingPost';
import CommentPost from 'flarum/forum/components/CommentPost';
import SubscriptionMenu from 'flarum/subscriptions/components/SubscriptionMenu';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import nickname from 'flarum/common/helpers/nickname';
import humanTime from 'flarum/common/helpers/humanTime';
import UserCard from 'flarum/forum/components/UserCard';
import UserPage from 'flarum/forum/components/UserPage';
import PostsUserPage from 'flarum/forum/components/PostsUserPage';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
import UserControls from 'flarum/forum/components/utils/UserControls';
import NickNameModal from 'flarum/nickNames/components/NickNameModal';
import SignNameModal from '../common/components/SignNameModal';
import RoleBindingModal from 'flarum/forum/dianLiang/RoleBindingModal';
import ExperienceValuelBar from '../common/components/ExperienceValuelBar';
import AffixedSidebar from 'flarum/forum/components/AffixedSidebar';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Separator from 'flarum/common/components/Separator';
import signName from 'flarum/forum/dianLiang/signName';
import NotificationsDropdown from 'flarum/forum/components/NotificationsDropdown';
import SettingPage from 'flarum/forum/dianLiang/SettingPage';
import ChangePasswordModal from 'flarum/forum/components/ChangePasswordModal';
import ChangeEmailModal from 'flarum/forum/components/ChangeEmailModal';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
import SuspendUserModal from 'flarum/forum/suspend/components/suspendUserModal';

export default function () {

  extend(PostsUserPage.prototype, 'oninit', function () {
    app.history.push(`u/${m.route.param('username')}`, app.translator.trans('flarum-tags.forum.header.back_to_tags_tooltip'));
  });

  extend(ChangePasswordModal.prototype, 'fields', function (fields) {
    fields.remove('help');
    fields.add(
      'oldPassword',
      <div className="Form-group">
        <label>{app.translator.trans('dl-response.forum.changePasswordModal.oldPassword')}:</label>
        <input
          type="password"
          className="FormControl"
          placeholder={app.translator.trans('dl-response.forum.changePasswordModal.oldPassword')}
          bidi={this.oldPassword}
          required
        />
      </div>,
      50
    );
    fields.add(
      'newPassword',
      <div className="Form-group">
        <label>{app.translator.trans('dl-response.forum.changePasswordModal.newPassword')}:</label>
        <input
          type="password"
          className="FormControl"
          placeholder={app.translator.trans('dl-response.forum.changePasswordModal.newPassword')}
          bidi={this.newPassword}
          required
        />
      </div>,
      50
    );
    fields.add(
      'newPasswordTwo',
      <div className="Form-group">
        <label>{app.translator.trans('dl-response.forum.changePasswordModal.newPasswordTwo')}:</label>
        <input
          type="password"
          className="FormControl"
          placeholder={app.translator.trans('dl-response.forum.changePasswordModal.newPasswordTwo')}
          bidi={this.newPasswordTwo}
          required
        />
      </div>,
      50
    );
    return fields;
  });

  ChangePasswordModal.prototype.onerror = function (error) {
    this.loading = false;
    AlertUtil.onWarn(app, error.responseText);
  };

  override(ChangePasswordModal.prototype, 'onsubmit', function (original, e) {
    e.preventDefault();

    if (this.oldPassword() === this.newPassword()) {
      AlertUtil.onWarn(app, app.translator.trans('dl-response.forum.changePasswordModal.warn.new_old_pwd_same'));
      return;
    }

    if (this.newPasswordTwo() !== this.newPassword()) {
      AlertUtil.onWarn(app, app.translator.trans('dl-response.forum.changePasswordModal.warn.new_pwd_two_same'));
      return;
    }

    if (!AlertUtil.checkPwd(this.newPassword())) {
      AlertUtil.onWarn(app, app.translator.trans('dl-alert.forum.pwd_rule'));
      return;
    }

    this.loading = true;

    app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/updatePwd',
        body: this.requestBody(),
        errorHandler: this.onerror.bind(this),
      })
      .then((res) => {
        AlertUtil.onSuccess(app, app.translator.trans('dl-response.forum.success.update_success'));
        this.loading = false;
        this.hide();
      });
  });

  override(ChangeEmailModal.prototype, 'onsubmit', function (original, e) {
    e.preventDefault();

    // If the user hasn't actually entered a different email address, we don't
    // need to do anything. Woot!
    if (this.email() === app.session.user!.email()) {
      this.hide();
      return;
    }

    this.loading = true;
    this.alertAttrs = null;

    app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/updateEmail',
        body: { password: this.password(), email: this.email() },
        errorHandler: this.onerror.bind(this),
      })
      .then((res) => {
        AlertUtil.onSuccess(app, app.translator.trans('dl-response.forum.success.update_success'));
        this.loading = false;
        this.hide();
        const userId = app.session.user?.id();
        app.store.find('users', userId);
      });
  });

  override(ChangeEmailModal.prototype, 'onerror', function (original,error) {
    this.loading = false;
    AlertUtil.onWarn(app, error.responseText);
  });

  override(ChangePasswordModal.prototype, 'requestBody', function (original) {
    return { oldPassword: this.oldPassword(), newPassword: this.newPassword() };
  });

  override(SettingPage.prototype, 'accountItems', function (original) {
    // if (app.store.models.type == 'phone') {
    const items = new ItemList();
    let user = app.session.user;
    if (user.canBeNotHideChangePwd()) {
      items.add(
        'changePassword',
        <Button className="Button" onclick={() => app.modal.show(ChangePasswordModal)}>
          {app.translator.trans('core.forum.settings.change_password_button')}
        </Button>,
        100
      );
    }

    // if (user.canBeNotHideChangeEmail()) {
    //   items.add(
    //     'changeEmail',
    //     <Button className="Button" onclick={() => app.modal.show(ChangeEmailModal)}>
    //       {app.translator.trans('core.forum.settings.change_email_button')}
    //     </Button>,
    //     90
    //   );
    // }

    items.add(
      'blackList',
      <LinkButton className="Button" href={app.route('user.ignoredUsers2')}>
        {app.translator.trans('dl-blackList.forum.blackList_button')}
      </LinkButton>,
      80
    );

    return items;
    // }else {
    //   return original();
    // }
  });

  override(UserCard.prototype, 'view', function (original) {
    // if (app.store.models.type == 'phone') {
    let user = this.attrs.user;
    // const controls = UserControls.controls(user, this).toArray();
    let color = user.color();
    let badges = user.badges().toArray();
    let userLevel = user?.userLevel();
    let levelConf = userLevel?.levelConf();
    let levelImg;
    let levelImgRes;
    let levelColor;
    let levelColorRes;
    let levelImgs = levelConf?.levelImg();
    if (levelImgs) {
      levelImgRes  = JSON.parse(levelImgs);
      levelImg = levelImgRes[app.data.pkgLogo.id];
    }
    let levelColors =  levelConf?.color();
    if (levelColors) {
      levelColorRes  = JSON.parse(levelColors);
      levelColor = levelColorRes[app.data.pkgLogo.id];
    }

    this.time;
    let unreadNotificationCount = app.session.user!.unreadNotificationCount();
    let unreadPostNotificationCount = app.session.user!.unreadPostNotificationCount();
    let unreadLikeNotificationCount = app.session.user!.unreadLikeNotificationCount();
    let walletStatus = app.session.user &&  app.forum.attribute('walletStatus');

    return (
      <div className={classList('UserCard', this.attrs.className)} style={color && { '--usercard-bg': color }}>
        <div className="darkenBackground new-darkenBackground">
          <div className="container extra-userCard-container">
            <div className="UserCard-profile">
              <div className="UserCard-box">
                {app.session.user == user && (
                  <LinkButton
                    className="person-pointNumber-container"
                    // href={history?.backUrl()}
                  >
                    <span className="person-pointNumer-icon">
                      <i class="fas fa-star"></i>
                    </span>
                    <span className="person-pointNumer">
                      {userLevel?.allIntegra() > 999
                        ? app.translator.trans('dl-person.forum.integra_more')
                        : app.translator.trans('dl-person.forum.integra', { integra: userLevel.allIntegra() })}
                    </span>
                  </LinkButton>
                )}
                <div className="Perssson-msg-fiter">
                  {this.attrs.editable ? (
                    <AvatarEditor user={user} className="UserCard-avatar" />
                  ) : (
                    <Link href={app.route.user(user)}>
                      <div className="UserCard-avatar">{avatar(user, { loading: 'eager' })}</div>
                      {/* {username(user)} */}
                    </Link>
                  )}
                  <div className="UserCard-identity-lin">
                    <h1 className="UserCard-identity">
                      <Button className="UserCard-identity-person" onclick={() => app.session.user === user && app.modal.show(NickNameModal)}>
                        {/* <span className="UserCard-identity-person-nickNameTitle">{app.translator.trans('dl-person.forum.nickName')}</span> */}
                        <span className="UserCard-identity-person-nickName UserCard-user-name">{nickname(user)}</span>
                        {app.session.user == user && <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-sr.png`}></img>}
                      </Button>
                    </h1>
                    <h1 className="">
                      <>
                        <Button
                          className="UserCard-identity-person autograph"
                          onclick={() => {app.session.user === user ? app.modal.show(SignNameModal) : this.onScrollToEnd()}}
                        >
                          <span className="UserCard-identity-person-nickNameTitle">{app.translator.trans('dl-person.forum.signName')}</span>&nbsp;
                          <div className="UserCard-identity-person-nickName person-container" id="scrollText">
                            <div className="scroll-text">{signName(user)}</div>
                          </div>
                          {app.session.user == user && (
                            <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-sr.png`}></img>
                          )}
                        </Button>
                        {app.session.user.isAdmin() &&  app.session.user != user &&(
                          <Button className="UserCard-identity-person-setting" onclick={() => app.modal.show(SuspendUserModal, { user })}>
                            <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-zt-fj.png`} />
                          </Button>
                        )}
                      </>
                    </h1>
                    <h1 className="">
                      {/* ID复制 */}
                      <>
                        <Button className="UserCard-identity-person" onclick={() => AlertUtil.copyToClipboar(user.uniqueID())}>
                          <span className="UserCard-identity-person-nickNameTitle">{app.translator.trans('dl-person.forum.ID')}</span>&nbsp;
                          <span className="UserCard-identity-person-nickName">{user.uniqueID()}</span>
                          <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-fz.png`}></img>
                        </Button>
                        {app.session.user == user && (
                          <LinkButton className="UserCard-identity-person-setting" href={app.route('settings2')}>
                            <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-szbai.png`} />
                          </LinkButton>
                        )}
                      </>
                    </h1>
                  </div>
                </div>

                <h2 className="UserCard-segmentation"></h2>

                <h1 className="UserCard-identity person-grade-container person-grade-container-lin">
                  {/* 经验值 */}
                  {ExperienceValuelBar.component({ user })}
                  {/* 等级 */}
                  <div className="person-grade-container">
                    <span className="person-grade-text">{app.translator.trans('dl-person.forum.experiences.grade')}</span>
                    <div className="DiscussionListItem-img-box">
                      <img src={levelImg} className="person-grade-img" />
                      <span className="DiscussionListItem-img-lv" style={`text-shadow: -1px -1px 0 ${levelColor}, 1px -1px 0 ${levelColor}, -1px 1px 0 ${levelColor}, 1px 1px 0 ${levelColor};`}>{userLevel?.levelConf()?.level()}</span>
                    </div>
                  </div>
                </h1>
              </div>
              {app.session.user === user && (
                <>
                  {/* 钱包 */}
                  <div className="User-wallet">
                    <div className="left">{app.translator.trans('dl-pay.forum.user.wallet_balance')}</div>
                    <div className="right">
                      <div className="money">${app.store.balance ? app.store.balance : '0'}</div>
                      {walletStatus &&
                      <div className="btn">
                      <a className="" href={app.route('pay', { type: 'postPayed' })}>
                        {app.translator.trans('dl-pay.forum.user.wallet_recharge')}
                      </a>
                    </div>}
                    </div>
                  </div>
                  {/* 中间按钮 */}
                  <div class="person-center-containers">
                    {/* 点赞数 */}
                    <div class="person-center-blocks">
                      <div class="person-center-top">{user.likeCount()}</div>
                      <div class="person-center-bottom">{app.translator.trans('dl-person.forum.like')}</div>
                    </div>
                    {/* 收藏数 */}
                    {/* <div class="person-center-blocks">
                    <div class="person-center-top">{user.followCount()}</div>
                    <div class="person-center-bottom">{app.translator.trans('dl-person.forum.fan')}</div>
                  </div> */}
                {/* 角色绑定 */}
                <img className="person-center-line" src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-fgx.png`}></img>
                <div class="person-center-blocks" onclick={() => app.modal.show(RoleBindingModal)}>
                <div class="person-center-top">{app.data['currentRole'] ? app.data['currentRole'].name : app.translator.trans('dl-pay.forum.operation.not_role')}</div>
                  <div class="person-center-bottom">{app.translator.trans('dl-pay.forum.user.current_bound_role')}</div>
                </div>
              </div>

                  {/* 邮箱那些按钮 */}
                  <div class="person-center-containers">
                    <div class="person-center-blocks">
                      <div class="person-center-top">
                        <LinkButton className={unreadNotificationCount?'Notification-unread':''} href={app.route('notifications')}>
                          <img
                            className="person-center-top-img"
                            src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-yhxx.png`}
                          />
                        </LinkButton>
                      </div>
                      <div class="person-center-bottom person-center-bottom-while">{app.translator.trans('dl-person.forum.mail')}</div>
                    </div>
                    <div class="person-center-blocks">
                      <div class="person-center-top">
                        <LinkButton className={unreadPostNotificationCount?'Notification-unread':''} href={app.route('notifications.comment', { type: 'newPost' })}>
                          <img
                            className="person-center-top-img"
                            src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-bhf.png`}
                          />
                        </LinkButton>
                      </div>
                      <div class="person-center-bottom person-center-bottom-while">{app.translator.trans('dl-person.forum.comment')}</div>
                    </div>
                    <div class="person-center-blocks">
                      <div class="person-center-top">
                        <LinkButton className={unreadLikeNotificationCount?'Notification-unread':''} href={app.route('notifications.likes', { type: 'postLiked' })}>
                          <img
                            className="person-center-top-img"
                            src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-bdz.png`}
                          />
                        </LinkButton>
                      </div>
                      <div class="person-center-bottom person-center-bottom-while">{app.translator.trans('dl-person.forum.likeMsg')}</div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
    // } else {
    //   return original();
    // }
  });

  extend(UserCard.prototype, 'infoItems', function (items) {
    items.remove('lastSeen');
    items.remove('joined');
    return items;
  });

  UserPage.prototype.title = function () {
    return <h4 className="App-titleControl person-title">{app.translator.trans('core.forum.header.profile_button')}</h4>;
  };

  extend(UserPage.prototype, 'oninit', function () {
    // if (app.store.models.type == 'phone') {
    app.history.push(`${this.attrs.routeName}`);
    // this.getRoleInfo();
    // }
  });

  override(UserPage.prototype, 'view', function (original) {
    // if (app.store.models.type == 'phone') {
    return (
      <div className={`UserPage ${this.user === app.session.user?'':'UserPage-ta'}`}>
        {this.title()}
        {this.user
          ? [
              <UserCard
                user={this.user}
                className="Hero UserHero"
                editable={this.user.canEdit() || this.user === app.session.user}
                controlsButtonClassName="Button"
              />,
              <div className="container extra-userPage-container">
                {(this.attrs.routeName == 'user.posts' || this.attrs.routeName == 'user.collections') && (
                  <div className="extra-UserPage-content">{listItems(this.contentItems().toArray())}</div>
                )}
                <div className="sideNavOffset UserPage-content">{this.content()}</div>
              </div>,
            ]
          : [<LoadingIndicator display="block" />]}
      </div>
    );
    // } else {
    //   return original();
    // }
  });
}
